import { Pipe, PipeTransform } from '@angular/core';
import { SensorItemDto } from '@artemis-software/wr-api';
import SensorUnitEnum = SensorItemDto.SensorUnitEnum;

const UNIT_SYMBOLS: Record<SensorUnitEnum, string> = {
  DEGREE_CELSIUS: '°C',
  DEGREE_KELVIN: 'K',
  MEGAWATT_HOUR: 'MWh',
  KILOWATT_HOUR: 'kWh',
  WATT: 'W',
  KILOWATT: 'kW',
  MEGAWATT: 'MW',
  CUBIC_METER: 'm³',
  CUBIC_CENTIMETER: 'cm³',
  CUBIC_METER_PER_HOUR: 'm³/h',
  LITER: 'l',
  LITER_PER_HOUR: 'l/h',
  BAR: 'bar',
  PASCAL: 'Pa',
  PERCENT: '%',
  PARTS_PER_MILLION: 'ppm',
  VOLT: 'V',
  AMPERE: 'A',
  HERTZ: 'Hz',
  NONE: 'k.A.',
};

@Pipe({
  standalone: false,
  name: 'sensorUnit'
})
export class SensorUnitPipe implements PipeTransform {
  transform(value: SensorUnitEnum | undefined | null): string {
    const symbol = value ? UNIT_SYMBOLS[value] : undefined;
    return symbol ?? 'k.A.';
  }
}
